import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumCacheEntityType implements BaseEnumType {
  private static allValues: EnumCacheEntityType[] = []; // make sure this is top-most
  
  public static none = new EnumCacheEntityType(0, "None", "enum_cache_entity_type_none");
  public static accountsLink = new EnumCacheEntityType(1, "AccountsLink", "enum_cache_entity_type_accounts_link");
  public static batchTemplate = new EnumCacheEntityType(2, "BatchTemplate", "enum_cache_entity_type_batch_template");
  public static caskSubLocation = new EnumCacheEntityType(3, "CaskSubLocation", "enum_cache_entity_type_cask_sub_location");
  public static caskSubSubLocation = new EnumCacheEntityType(4, "CaskSubSubLocation", "enum_cache_entity_type_cask_sub_sub_location");
  public static caskSubType = new EnumCacheEntityType(5, "CaskSubType", "enum_cache_entity_type_cask_sub_type");
  public static caskType = new EnumCacheEntityType(6, "CaskType", "enum_cache_entity_type_cask_type");
  public static collectionTime = new EnumCacheEntityType(7, "CollectionTime", "enum_cache_entity_type_collection_time");
  public static communicationSubject = new EnumCacheEntityType(8, "CommunicationSubject", "enum_cache_entity_type_communication_subject");
  public static communicationType = new EnumCacheEntityType(9, "CommunicationType", "enum_cache_entity_type_communication_type");
  public static courier = new EnumCacheEntityType(10, "Courier", "enum_cache_entity_type_courier");
  public static creditTerm = new EnumCacheEntityType(11, "CreditTerm", "enum_cache_entity_type_credit_term");
  public static deliveryArea = new EnumCacheEntityType(12, "DeliveryArea", "enum_cache_entity_type_delivery_area");
  public static site = new EnumCacheEntityType(13, "Site", "enum_cache_entity_type_site");
  public static eprBom = new EnumCacheEntityType(14, "EprBom", "enum_cache_entity_type_epr_bom");
  public static glCode = new EnumCacheEntityType(15, "GlCode", "enum_cache_entity_type_gl_code");
  public static group = new EnumCacheEntityType(16, "Group", "enum_cache_entity_type_group");
  public static item = new EnumCacheEntityType(17, "Item", "enum_cache_entity_type_item");
  public static lead = new EnumCacheEntityType(18, "Lead", "enum_cache_entity_type_lead");
  public static leadLossReason = new EnumCacheEntityType(19, "LeadLossReason", "enum_cache_entity_type_lead_loss_reason");
  public static leadPipelineStage = new EnumCacheEntityType(20, "LeadPipelineStage", "enum_cache_entity_type_lead_pipeline_stage");
  public static leadSource = new EnumCacheEntityType(21, "LeadSource", "enum_cache_entity_type_lead_source");
  public static orderTypeText = new EnumCacheEntityType(22, "OrderTypeText", "enum_cache_entity_type_order_type_text");
  public static outlet = new EnumCacheEntityType(23, "Outlet", "enum_cache_entity_type_outlet");
  public static outletRating = new EnumCacheEntityType(24, "OutletRating", "enum_cache_entity_type_outlet_rating");
  public static outletSubType = new EnumCacheEntityType(25, "OutletSubType", "enum_cache_entity_type_outlet_sub_type");
  public static outletType = new EnumCacheEntityType(26, "OutletType", "enum_cache_entity_type_outlet_type");
  public static packageType = new EnumCacheEntityType(27, "PackageType", "enum_cache_entity_type_package_type");
  public static palletType = new EnumCacheEntityType(28, "PalletType", "enum_cache_entity_type_pallet_type");
  public static priceList = new EnumCacheEntityType(29, "PriceList", "enum_cache_entity_type_price_list");
  public static pricingCategory = new EnumCacheEntityType(30, "PricingCategory", "enum_cache_entity_type_pricing_category");
  public static productBrand = new EnumCacheEntityType(31, "ProductBrand", "enum_cache_entity_type_product_brand");
  public static qcTest = new EnumCacheEntityType(32, "QcTest", "enum_cache_entity_type_qc_test");
  public static recipe = new EnumCacheEntityType(33, "Recipe", "enum_cache_entity_type_recipe");
  public static regionalTax = new EnumCacheEntityType(34, "RegionalTax", "enum_cache_entity_type_regional_tax");
  public static salesArea = new EnumCacheEntityType(35, "SalesArea", "enum_cache_entity_type_sales_area");
  public static salesCode = new EnumCacheEntityType(36, "SalesCode", "enum_cache_entity_type_sales_code");
  public static salesQuestion = new EnumCacheEntityType(37, "SalesQuestion", "enum_cache_entity_type_sales_question");
  public static stockGroup = new EnumCacheEntityType(38, "StockGroup", "enum_cache_entity_type_stock_group");
  public static stockLocation = new EnumCacheEntityType(39, "StockLocation", "enum_cache_entity_type_stock_location");
  public static supplierManufacturer = new EnumCacheEntityType(40, "SupplierManufacturer", "enum_cache_entity_type_supplier_manufacturer");
  public static taskNotificationSetting = new EnumCacheEntityType(41, "TaskNotificationSetting", "enum_cache_entity_type_task_notification_setting");
  public static taskQueue = new EnumCacheEntityType(42, "TaskQueue", "enum_cache_entity_type_task_queue");
  public static taskType = new EnumCacheEntityType(43, "TaskType", "enum_cache_entity_type_task_type");
  public static tenant = new EnumCacheEntityType(44, "Tenant", "enum_cache_entity_type_tenant");
  public static tenantSettings = new EnumCacheEntityType(45, "TenantSettings", "enum_cache_entity_type_tenant_settings");
  public static unitOfMeasure = new EnumCacheEntityType(46, "UnitOfMeasure", "enum_cache_entity_type_unit_of_measure");
  public static vatCode = new EnumCacheEntityType(47, "VatCode", "enum_cache_entity_type_vat_code");
  public static vehicle = new EnumCacheEntityType(48, "Vehicle", "enum_cache_entity_type_vehicle");
  public static vessel = new EnumCacheEntityType(49, "Vessel", "enum_cache_entity_type_vessel");
  public static vesselCapability = new EnumCacheEntityType(50, "VesselCapability", "enum_cache_entity_type_vessel_capability");
  public static vesselMaintenanceProcess = new EnumCacheEntityType(51, "VesselMaintenanceProcess", "enum_cache_entity_type_vessel_maintenance_process");
  public static vesselState = new EnumCacheEntityType(52, "VesselState", "enum_cache_entity_type_vessel_state");
  public static vesselType = new EnumCacheEntityType(53, "VesselType", "enum_cache_entity_type_vessel_type");
  public static vesselValuation = new EnumCacheEntityType(54, "VesselValuation", "enum_cache_entity_type_vessel_valuation");
  public static obsolete_CaskLocation = new EnumCacheEntityType(55, "Obsolete_CaskLocation", "enum_cache_entity_type_obsolete__cask_location");
  public static distributionConfiguration = new EnumCacheEntityType(56, "DistributionConfiguration", "enum_cache_entity_type_distribution_configuration");
  public static emailSettings = new EnumCacheEntityType(57, "EmailSettings", "enum_cache_entity_type_email_settings");
  public static pickingStrategy = new EnumCacheEntityType(58, "PickingStrategy", "enum_cache_entity_type_picking_strategy");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumCacheEntityType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumCacheEntityType.none; }
  public isAccountsLink() { return this === EnumCacheEntityType.accountsLink; }
  public isBatchTemplate() { return this === EnumCacheEntityType.batchTemplate; }
  public isCaskSubLocation() { return this === EnumCacheEntityType.caskSubLocation; }
  public isCaskSubSubLocation() { return this === EnumCacheEntityType.caskSubSubLocation; }
  public isCaskSubType() { return this === EnumCacheEntityType.caskSubType; }
  public isCaskType() { return this === EnumCacheEntityType.caskType; }
  public isCollectionTime() { return this === EnumCacheEntityType.collectionTime; }
  public isCommunicationSubject() { return this === EnumCacheEntityType.communicationSubject; }
  public isCommunicationType() { return this === EnumCacheEntityType.communicationType; }
  public isCourier() { return this === EnumCacheEntityType.courier; }
  public isCreditTerm() { return this === EnumCacheEntityType.creditTerm; }
  public isDeliveryArea() { return this === EnumCacheEntityType.deliveryArea; }
  public isSite() { return this === EnumCacheEntityType.site; }
  public isEprBom() { return this === EnumCacheEntityType.eprBom; }
  public isGlCode() { return this === EnumCacheEntityType.glCode; }
  public isGroup() { return this === EnumCacheEntityType.group; }
  public isItem() { return this === EnumCacheEntityType.item; }
  public isLead() { return this === EnumCacheEntityType.lead; }
  public isLeadLossReason() { return this === EnumCacheEntityType.leadLossReason; }
  public isLeadPipelineStage() { return this === EnumCacheEntityType.leadPipelineStage; }
  public isLeadSource() { return this === EnumCacheEntityType.leadSource; }
  public isOrderTypeText() { return this === EnumCacheEntityType.orderTypeText; }
  public isOutlet() { return this === EnumCacheEntityType.outlet; }
  public isOutletRating() { return this === EnumCacheEntityType.outletRating; }
  public isOutletSubType() { return this === EnumCacheEntityType.outletSubType; }
  public isOutletType() { return this === EnumCacheEntityType.outletType; }
  public isPackageType() { return this === EnumCacheEntityType.packageType; }
  public isPalletType() { return this === EnumCacheEntityType.palletType; }
  public isPriceList() { return this === EnumCacheEntityType.priceList; }
  public isPricingCategory() { return this === EnumCacheEntityType.pricingCategory; }
  public isProductBrand() { return this === EnumCacheEntityType.productBrand; }
  public isQcTest() { return this === EnumCacheEntityType.qcTest; }
  public isRecipe() { return this === EnumCacheEntityType.recipe; }
  public isRegionalTax() { return this === EnumCacheEntityType.regionalTax; }
  public isSalesArea() { return this === EnumCacheEntityType.salesArea; }
  public isSalesCode() { return this === EnumCacheEntityType.salesCode; }
  public isSalesQuestion() { return this === EnumCacheEntityType.salesQuestion; }
  public isStockGroup() { return this === EnumCacheEntityType.stockGroup; }
  public isStockLocation() { return this === EnumCacheEntityType.stockLocation; }
  public isSupplierManufacturer() { return this === EnumCacheEntityType.supplierManufacturer; }
  public isTaskNotificationSetting() { return this === EnumCacheEntityType.taskNotificationSetting; }
  public isTaskQueue() { return this === EnumCacheEntityType.taskQueue; }
  public isTaskType() { return this === EnumCacheEntityType.taskType; }
  public isTenant() { return this === EnumCacheEntityType.tenant; }
  public isTenantSettings() { return this === EnumCacheEntityType.tenantSettings; }
  public isUnitOfMeasure() { return this === EnumCacheEntityType.unitOfMeasure; }
  public isVatCode() { return this === EnumCacheEntityType.vatCode; }
  public isVehicle() { return this === EnumCacheEntityType.vehicle; }
  public isVessel() { return this === EnumCacheEntityType.vessel; }
  public isVesselCapability() { return this === EnumCacheEntityType.vesselCapability; }
  public isVesselMaintenanceProcess() { return this === EnumCacheEntityType.vesselMaintenanceProcess; }
  public isVesselState() { return this === EnumCacheEntityType.vesselState; }
  public isVesselType() { return this === EnumCacheEntityType.vesselType; }
  public isVesselValuation() { return this === EnumCacheEntityType.vesselValuation; }
  public isObsolete_CaskLocation() { return this === EnumCacheEntityType.obsolete_CaskLocation; }
  public isDistributionConfiguration() { return this === EnumCacheEntityType.distributionConfiguration; }
  public isEmailSettings() { return this === EnumCacheEntityType.emailSettings; }
  public isPickingStrategy() { return this === EnumCacheEntityType.pickingStrategy; }

  public static getValues(): readonly EnumCacheEntityType[] {
    return EnumCacheEntityType.allValues;
  }

  public static getValuesExcept0(): readonly EnumCacheEntityType[] {
    return EnumCacheEntityType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumCacheEntityType {
    const found = EnumCacheEntityType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumCacheEntityType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumCacheEntityType): EnumCacheEntityType {
    const found = name ? EnumCacheEntityType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumCacheEntityType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumCacheEntityType>): boolean {
    return this.key === other?.key;
  }
}